import React from 'react';

import { Home } from '../Home/Home';

export const HomePage: React.FC = () => <Home />;
